import type { PartialSkill, SkillScope } from "~/services/skills";

// Display order for the skills picker: broad baseline first, most personal
// last. Scopes outside this list (PROJECT, CUSTOMER) sort after the known
// ones, alphabetically by scope name as a stable fallback.
const SCOPE_ORDER: Record<SkillScope, number> = {
  SYSTEM: 0,
  AGENT: 1,
  DATASET: 2,
  USER: 3,
  PROJECT: 4,
  CUSTOMER: 5,
};

const scopeRank = (scope: SkillScope): number => SCOPE_ORDER[scope] ?? Number.MAX_SAFE_INTEGER;

// Orders skills by scope (System → Agent → Dataset → User), then
// alphabetically by name within each scope.
function compareSkills(a: PartialSkill, b: PartialSkill): number {
  const byScope = scopeRank(a.scope) - scopeRank(b.scope);
  if (byScope !== 0) return byScope;
  return a.name.localeCompare(b.name);
}

export function sortSkills(skills: PartialSkill[]): PartialSkill[] {
  return [...skills].sort(compareSkills);
}
